// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3ZCIk","footer":"ModalInfo_footer__1ahxX"};